export const PACKAGE_LABELS = {
  starter: 'Starter',
  growth: 'Growth',
  professional: 'Professional'
};

export function servicesPackageHash(packageKey) {
  return `package-${packageKey}`;
}

export function computeScopeOutcome({ siteType, pageBand, integrations }) {
  const int = new Set(integrations || []);
  if (siteType === 'commerce' || siteType === 'customapp') {
    return {
      outcome: 'contact',
      reason:
        'E‑commerce builds and custom web applications need discovery, security review, and scope agreed in writing — they sit outside the standard brochure packages.'
    };
  }
  if (int.has('payments')) {
    return {
      outcome: 'contact',
      reason:
        'Taking payments on-site needs the right compliance, gateway choices, and testing — we scope that with you rather than assume a brochure tier.'
    };
  }
  if (pageBand === '9+') {
    return {
      outcome: 'contact',
      reason:
        'Our published website packages cover up to eight pages on the top tier; larger or programme-style builds need a tailored plan.'
    };
  }

  let packageKey = 'growth';
  if (pageBand === '1') {
    packageKey = 'starter';
  } else if (pageBand === '2-5') {
    packageKey = 'growth';
  } else if (pageBand === '6-8') {
    packageKey = 'professional';
  }

  if (pageBand === '1' && siteType === 'brochure' && !int.has('bookings') && !int.has('crm')) {
    packageKey = 'starter';
  }

  if (int.has('crm') && int.has('bookings') && pageBand !== '1') {
    packageKey = 'professional';
  }

  return { outcome: 'package', packageKey };
}
